import { useEffect } from 'react';
import { getListingsImpressions } from '../../util/api';
import { useRequest } from '../../hooks/useRequest';

export const useImpressionsRequest = ({ listingId, setImpressions }) => {
    const { loading, request } = useRequest();

    useEffect(() => {
        if (listingId) {
            request(
                async () => await getListingsImpressions(listingId),
                data => setImpressions(data?.impressionsNum || 0)
            );
        }
    }, [listingId]);

    return { loading };
};
